import { render } from "./Study.vue?vue&type=template&id=4c2f5f60"
import script from "./Study.vue?vue&type=script&lang=js"
export * from "./Study.vue?vue&type=script&lang=js"
script.render = render

export default script